import { bangkokDayKey } from './history-search';
import type { EventType } from './index';
export interface DayBookend { type: EventType; occurredAt: string; sequence?: number; }
export function dayFlowState(rows: readonly DayBookend[], now = new Date().toISOString()) {
  const today = bangkokDayKey(now);
  const bookends = rows.filter(row => (row.type === 'start' || row.type === 'end') && Date.parse(row.occurredAt) <= Date.parse(now))
    .sort((a,b) => Date.parse(b.occurredAt) - Date.parse(a.occurredAt) || (b.sequence ?? 0) - (a.sequence ?? 0));
  // The closed lock is per Bangkok day: yesterday's return-home must not block
  // a new departure after midnight.
  const todayBookends = bookends.filter(row => bangkokDayKey(row.occurredAt) === today);
  return { latest: todayBookends[0]?.type, closed: todayBookends[0]?.type === 'end', lastBookend: bookends[0]?.type };
}
export function blockedAfterReturn(type: EventType, closed: boolean) { return closed && (type === 'trip' || type === 'charge'); }

export function dayFormType(state: { latest?: EventType; lastBookend?: EventType; closed: boolean }): 'start' | 'end' {
  return (state.lastBookend ?? state.latest) === 'start' && !state.closed ? 'end' : 'start';
}
export interface ReturnReading { eventId: string; version: number; type: EventType; occurredAt: string; sequence?: number; odometer?: number | null; batteryPct?: number | null; }
export function lastReturnReadings(rows: readonly ReturnReading[]) {
  const latest = new Map<string, ReturnReading>();
  for (const row of rows) if (!latest.has(row.eventId) || row.version >= latest.get(row.eventId)!.version) latest.set(row.eventId, row);
  const returned = [...latest.values()].filter(row => row.type === 'end').sort((a,b) => Date.parse(b.occurredAt)-Date.parse(a.occurredAt) || (b.sequence ?? 0)-(a.sequence ?? 0))[0];
  return { odo: returned?.odometer ?? undefined, bat: returned?.batteryPct ?? undefined };
}
